import { useContext, useEffect, useState } from "react";
import { AddSessionFormContext } from "./AddSessionFormContext";
import { ISession } from "../../../../../types/dashboard";
import { AddSessionForm, IAddSessionFormData } from "./AddSessionForm";
import React from "react";
import { AppContext } from "../../../../../appContext";
import { addSessionValidate, ISessionErrors } from "./AddSessionValidate";
import { DashboardContext } from "../../../DashboardContext";
import { dateToTimezoneAwareDatetime, parseTimezoneAwareDatetime } from "../../../../../utils/timezone";

interface IAddSessionFormControllerProps extends React.PropsWithChildren{
    initialSessionData: ISession;
    onSave: (session: ISession)=>void;
    onDelete: (session: ISession)=>void;
}

export const AddSessionFormContexted = ()=>{
    const { clients } = useContext(AppContext);
    const {formData, setFormData, errors, setErrors} = useContext(AddSessionFormContext);

    return <AddSessionForm errors={errors} clients={clients} data={formData} onChange={setFormData}>
    </AddSessionForm>
}

export const AddSessionFormController = ({children, initialSessionData, onSave, onDelete}: IAddSessionFormControllerProps)=>{
    const sessionData = initialSessionData;
    const {selectedClient} = useContext(DashboardContext);

    const [sessionFormData, setSessionFormData] = useState<IAddSessionFormData>({
        title: '',
        selectedClient: selectedClient.id,
        date: new Date(),
        timeFrom: new Date(),
        timeTo: new Date(),
        repeatParams: {}
    });

    const handleSave = ()=>{
        const {isValid, errors} = addSessionValidate(sessionFormData);
        setErrors(errors);
        if (!isValid){
            return;
        }
        const {date, timeFrom, timeTo, title, selectedClient, repeatParams} = sessionFormData;
        const fullDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), timeFrom.getHours(), timeFrom.getMinutes(), 0, 0);
        const fullDateTo = new Date(date.getFullYear(), date.getMonth(), date.getDate(), timeTo.getHours(), timeTo.getMinutes(), 0, 0);
        
        // Create session with new timezone-aware datetime format
        onSave({
            id: sessionData?.id || undefined,
            title: title,
            client: selectedClient,
            startDatetime: dateToTimezoneAwareDatetime(fullDate),
            endDatetime: dateToTimezoneAwareDatetime(fullDateTo),
            status: 'Upcoming',
            ...repeatParams
        });
    }

    const handleDelete = ()=>{
        onDelete(sessionData);
    }

    const [errors, setErrors] = useState<ISessionErrors>({});

    useEffect(()=>{
        if (!initialSessionData){
            return;
        }
        
        // Handle both new timezone-aware format and legacy format during migration
        let startDate: Date, endDate: Date;
        
        try {
            if (initialSessionData.startDatetime && initialSessionData.endDatetime) {
                // Use new timezone-aware format
                startDate = parseTimezoneAwareDatetime(initialSessionData.startDatetime);
                endDate = parseTimezoneAwareDatetime(initialSessionData.endDatetime);
            } else if (initialSessionData.date && initialSessionData.dateTo) {
                // Fallback to legacy format
                startDate = new Date(initialSessionData.date);
                endDate = new Date(initialSessionData.dateTo);
            } else {
                // Default if no valid dates
                startDate = new Date();
                endDate = new Date(Date.now() + 60 * 60 * 1000); // 1 hour later
            }
        } catch (e) {
            console.warn('Failed to parse session dates:', e);
            startDate = new Date();
            endDate = new Date(Date.now() + 60 * 60 * 1000);
        }
        
        setSessionFormData({
            title: initialSessionData.title,
            selectedClient: initialSessionData.client,
            date: startDate,
            timeFrom: startDate,
            timeTo: endDate,
            repeatParams: {
                repeat: initialSessionData.repeat,
                repeatEvery: initialSessionData.repeatEvery,
                repeatInterval: initialSessionData.repeatInterval
            }
        })
    }, [initialSessionData]);

    console.log('session id', initialSessionData.id, initialSessionData);

    return <AddSessionFormContext.Provider value={{
        editId: initialSessionData?.id,
        formData: sessionFormData,
        setFormData: setSessionFormData,
        errors,
        setErrors,

        deleteSession: handleDelete,
        saveSession: handleSave
    }}>
        {children}
    </AddSessionFormContext.Provider>
}